import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import "./i18n"; // Initialize i18n before rendering
import App from "./App.tsx";
import "./index.css";

// Initialize error monitoring (no-op when VITE_SENTRY_DSN is not set)
initSentry();

// ---------------------------------------------------------------------------
// Stale-deployment recovery
//
// After every new deploy, previously-open tabs still reference old,
// content-hashed JS chunk URLs (e.g. Reset-BJJjvOT8.js) that no longer exist
// once the deployment overwrote them. That surfaces as
// "Failed to fetch dynamically imported module" and would otherwise leave
// users stuck on a broken screen (e.g. mid password reset). Detect it once
// per page load and force a hard reload to pick up the current build.
// ---------------------------------------------------------------------------
const RELOAD_GUARD_KEY = "tandava:stale-chunk-reload";

function recoverFromStaleChunk() {
  if (sessionStorage.getItem(RELOAD_GUARD_KEY)) return; // avoid reload loops
  sessionStorage.setItem(RELOAD_GUARD_KEY, "1");
  window.location.reload();
}

window.addEventListener("vite:preloadError", recoverFromStaleChunk);

window.addEventListener("unhandledrejection", (event) => {
  const message = String(event.reason?.message ?? event.reason ?? "");
  if (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  ) {
    recoverFromStaleChunk();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
